import createAPI from '../axios'

// 通用方法 API
const common = {
    // 审核
    audit: {
        auditParam: config => createAPI('/common/audit/auditParam', 'post', config),

        audit: config => createAPI('/common/audit/audit', 'post', config),

        list: config => createAPI('/common/audit/list', 'post', config),
    },
};

export default common;



// WEBPACK FOOTER //
// ./src/api/modules/commonAdultEducation.js